<template>
  <div class="card-header">
    <h5 class="title-header">文件信息</h5>
    <div class="title-content">
      <span class="title-text title-text-left">文件名称</span>
      <span class="title-text">{{ data.name }}</span>
    </div>
    <div class="title-content">
      <span class="title-text title-text-left">文件编码</span>
      <span class="title-text">{{ data.code }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CardHeader",
  data() {
    return {};
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  components: {},
  computed: {},
  watch: {},
  methods: {}
};
</script>
<style lang="less">
.card-header {
  // margin-top: 10px;
  height: 115px;
  background: white;
  padding: 0 0px 15px 15px;
  box-shadow: 0 2px 3px #0000152b;
}
.title-header {
  padding: 15px 0 15px 0px;
  font-size: 16px;
  border-bottom: 1px solid #dcdcdc;
}
.title-content {
  padding-top: 8px;
}
.title-text {
  padding-right: 15px;
  font-size: 14px;
}
.title-text-left {
  display: inline-block;
  width: 60px;
  color: #969799;
}
</style>
